import { render, staticRenderFns } from "./CustomerCallSheetsArchives.vue?vue&type=template&id=4c1b6eb3&scoped=true&"
import script from "./CustomerCallSheetsArchives.vue?vue&type=script&lang=ts&"
export * from "./CustomerCallSheetsArchives.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerCallSheetsArchives.vue?vue&type=style&index=0&id=4c1b6eb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1b6eb3",
  null
  
)

export default component.exports